export const CACHE_EXPIRATION_MS = 14 * 24 * 60 * 60 * 1000; // 14 Days
